import React, { Component } from "react";
import Editor from "../../../common/Quill";
import { getAnswers, getQuestion, removeAnswer } from "../../../../services/formService";
import { toast, ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import { checkImgSize } from "../../../common/commonFuncs";
import * as Icon from "react-feather";
import { logActivity } from '../../../../services/utilService';

class TypeMultiChoice extends Component {
    
  constructor(props) {
    super(props);
    this.state = {
      Question_ID: this.props.Question_ID,
      Question_Answers: [],
      Allow_Multiple_Selection: false,
      Widget_ID: this.props.Widget_ID
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  async componentDidMount() {
    let { data: Question_Answers } = await getAnswers(this.state.Question_ID), 
        {data: Question_Config} = await getQuestion(this.state.Widget_ID)
    this.setState({...this.state, Question_Answers: Question_Answers, Allow_Multiple_Selection:Question_Config[0].Allow_Multiple_Selection});
  }

  handleSave() {
    if ((this.state.Question_Answers).length >= 2) {
      const Question_ID = this.props.onSave(this.state.Question_Answers);
      this.setState({ Question_ID });
      logActivity('/formBuilder','WIDGET_MCQUESTION_SAVE_SUCCESS');
    }
    else {
      toaster('error', 'Please correct fields before saving')
      logActivity('/formBuilder','WIDGET_MCQUESTION_SAVE_FAILED');
    }
  }

  handleRemove() {
    this.props.onRemove();
  }

  handldAnswerChange = (text, index) => {
    const Question_Answers = [...this.state.Question_Answers];
    if (!checkImgSize(text)) {
      toaster('error', 'Image file size cannot exceed 1MB.', { position: toast.POSITION.TOP_CENTER });
    } else {
      Question_Answers[index]["Answer_Text"] = text;
    }
    this.setState({ Question_Answers });
  };

  handleAnswerRemove = async (index) => {
    const answer = this.state.Question_Answers[index];
    const { data } = await removeAnswer(answer.Answer_ID);
    if (data.includes("Done")) {
      const Question_Answers = [...this.state.Question_Answers];
      Question_Answers.splice(index, 1);
      this.setState({ Question_Answers });
      toaster('success', 'Answer removed');
      logActivity('/formBuilder','WIDGET_ANSWER_DELETE_SUCCESS');
    } else {
      toaster('error', data);
      logActivity('/formBuilder','WIDGET_ANSWER_DELETE_FAILED');
    }
  };

  handleAnswerAdd = () => {
    const Question_Answers = [...this.state.Question_Answers, { Answer_ID: 0, Answer_Text: "" }];
    this.setState({ Question_Answers });
  };

  handleQuestionType = async (Allow_Multiple_Selection) => {
    const { onMultipleSelection } = this.props;
		onMultipleSelection(Allow_Multiple_Selection);
    this.setState({ ...this.state, Allow_Multiple_Selection });
  };

  render() {
    let { Question_ID, Question_Answers } = this.state;
    return (
      <React.Fragment>
        {/* Single or Multi Selection option */}
        <div>
          <div className='form-check form-check-inline'>
            <input
              type='radio'
              className='form-check-input'
              id={Question_ID + 'single_selection'}
              name={Question_ID + 'MCType'}
              value='single'
              checked={!this.state.Allow_Multiple_Selection}
              onChange={(e) => this.handleQuestionType(false)}
            />
            <label htmlFor='single_selection' className='form-check-label'>
              Single selection
            </label>
          </div>

          <div className='form-check form-check-inline'>
            <input
              type='radio'
              className='form-check-input'
              id={Question_ID + 'multiple_selection'}
              name={Question_ID + 'MCType'}
              value='multiple'
              checked={this.state.Allow_Multiple_Selection}
              onChange={(e) => this.handleQuestionType(true)}
            />
            <label htmlFor='multiple_selection' className='form-check-label'>
              Allow multiple selection
            </label>
          </div>
        </div>

        <div>
          <label>Question Answers</label>
          {Question_Answers.map((row, idx) => {
            return (
              <div className="form-row" key={idx}>
                <div className="form-group col-md-1">{idx + 1}.</div>
                <div className="form-group col-md-10">
                  <Editor
                    value={row.Answer_Text}
                    onChange={(value) => this.handldAnswerChange(value, idx)}
                  />
                </div>

                <div className="form-group col-md-1">
                  {Question_Answers.length !== 1 && (
                    <button
                      className="btn btn-outline-warning btn-sm"
                      onClick={() => this.handleAnswerRemove(idx)}
                    >
                      Remove
                    </button>
                  )}
                </div>
              </div>
            );
          })}
          <div className="text-center mt-1">
            <button
              className="btn btn-outline-primary btn-icon btn-sm"
              onClick={this.handleAnswerAdd}
            >
              <Icon.Plus size={18} />
            </button>
          </div>
        </div>

        <div className="float-right">
          <button
            className="btn btn-outline-primary m-2"
            onClick={this.handleSave}
          >
            Save
          </button>
          <button
            className="btn btn-outline-danger"
            onClick={this.handleRemove}
          >
            Delete
          </button>
        </div>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default TypeMultiChoice;
